<div class="auth-page">
  <main class="auth-main">
    <header class="auth-brand">
      <a class="auth-brand__link" href="/" title="На главную">
        <img
          class="auth-brand__logo"
          [src]="'/assets/imgs/logo.png'"
          [alt]="environment.appTitle"
          [title]="environment.appTitle"
        />
      </a>
    </header>

    <div class="auth-form-wrap">
      <router-outlet />
    </div>
  </main>
</div>
